<xux-icon-defs></xux-icon-defs>

<!-- Generic list view component -->
<xux-grid-actions-panel-custom
  *ngIf="!options?.hideActionPanel"
  (action)="emitAction($event)"
  [i18n]="staticTextContent?.xuxGridActionsPanel"
  [options]="options"
  [view]="view"
  [buttons]="buttons"
  [pageCount]="pageCount"
  [showSearch]="showSearch"
  [gridRowHeight]="gridRowHeight"
  [searchPlaceholder]="searchPlaceholder"
  [allCollapsed]="allCollapsed"
  [artificialInputCheckForSearchPanel]="artificialInputCheckForSearchPanel"
>
  <ng-content select=[actions-panel-content]></ng-content>
</xux-grid-actions-panel-custom>

<div class="grid-wrapper" [ngClass]="gridRowHeight" [class.no-action-pannel]="options?.hideActionPanel" [class.pinned-rows]="pinnedRowPresent">
  <ag-grid-angular
    class="ag-dm"
    [class.disabled]="options?.disabled"
    [class.infinite]="isInfiniteRowModel()"
    [style.height]="gridHeight$ | async"
    [style.minHeight]="gridMinHeight"
    [animateRows]="options?.animateRows"
    [context]="context"
    [rowData]="getRowData()"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefinitions"
    [frameworkComponents]="frameworkComponents"
    [pinnedTopRowData]="pinnedTopRowData"
    [cacheBlockSize]="gridOptions.cacheBlockSize"
    [overlayNoRowsTemplate]="customOverlayNoRowsTemplate"
    >
  </ag-grid-angular>
  <div class="inline-button-wrapper" *ngIf="options?.inlineAdd">
    <a
      class="add-new-item"
      (click)="insertNewItem()"
      [class.disabled]="isCellEditInProgress || (options?.disabledInlineAddObs | async)"
    >
      {{inlineAddButtonCaption | translate}}
    </a>
  </div>
</div>

<xux-loader-small
  [background]="'transparent'"
  [cssScale]="0.75"
  [isLoaderVisible]="showLoader"
></xux-loader-small>
